import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { AadhaarService } from 'projects/services/src/app/API/aadharService/aadhaar.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { STRING, KEYS } from '../../types';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
declare var toastr;

@Component({
	selector: 'app-aadhar',
	templateUrl: './aadhar.component.html',
	styleUrls: ['./aadhar.component.css']
})
export class AadharComponent implements OnInit {

	@Input() aadharNumber: string;
	@Input() elementClass: string;
	@Input() formElement: any = {};
	@Input() formValue: AbstractControl;
	@Input() disabled: boolean;
	@Input() value: any = {
		aadharNumber : '',
		encryptedValue: '',
		aadhaarRef : '',
		aadhaarVerified : false
	};
	forceDisable = false;
	@Input() type: string;
	@Output() valueChange = new EventEmitter();
	@Output() blur = new EventEmitter();
	_isAadhaarValidated: boolean;
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	name: string;
	labelClass: any = [];
	inputClass: any = [];
	rowClass: any = [];
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	loggedInUser: any;
	constructor(
		private scriptLoaderService: ScriptLoaderService,
		private aadharService: AadhaarService,
		private currentService: CurrentUserService
	) {
	}

	ngOnInit() {
		if (this.formValue) {
			this.formValue.valueChanges.subscribe(val => {
				this.onFormValueChange(val);
			});
		}
		if (this.formElement || Object.keys[this.formElement] !== 0) {
			this._formatView();
			this.disabled = this.formElement.disabled || false;
			this.value = this.formElement.value || this._generateObject();
			if (this.value.aadhaarVerified) {
				this.getAdharNumber(this.value);
			}
		}
		this.scriptLoaderService.addScriptTagToElementDOM(
			'../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		);
		this.getCurrentDetails()
	}

	// tslint:disable-next-line:max-line-length
	private _generateObject(aadharNumber: string = '', encryptedValue: string = '', aadhaarRef: string = '', aadhaarVerified: boolean = null) {
		return {
			aadharNumber ,
			encryptedValue,
			aadhaarRef,
			aadhaarVerified
		};
	}

	onFormValueChange(val) {
		val = val || STRING.EMPTY;
		if (typeof val === STRING.STRING) {
			if (val !== STRING.EMPTY) {
				this.getAdharNumber(val);
				return;
			}
			val = this._generateObject();
			this.forceDisable = this.disabled && false;
		}
		if (!Helpers.compareObj(this.value, val)) {
			this.value = val;
			this.formValue.markAsPristine();
			this.onChange();
		}
		if (this.formElement.markAsUntouched) {
			this.formValue.markAsPristine();
			this.formValue.markAsUntouched();
			this.formElement.markAsUntouched = false;
		}
	}

	private getCurrentDetails() {
		this.currentService.getCurrentUser().subscribe(res => {
			this.loggedInUser = res;
		})
	}

	get aadharVerified() {
		if (this.value && this.value.aadhaarRef) {
			return true;
		}
		return false;
	}

	private _formatView() {
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
	}


	// private _formatView() {
	// 	// this.labelClass = ['col-form-label field-label'];
	// 	this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
	// 	this.inputClass = [];
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	if (this.formElement.align && this.formElement.align === 6) {
	// 		// derivedLabelClass.push('col-4');
	// 		// derivedInputClass.push('col-8');
	// 		derivedLabelClass.push(FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(4));
	// 		derivedInputClass.push(FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(8));
	// 	} else {
	// 		// derivedLabelClass.push('col-2');
	// 		// derivedInputClass.push('col-10');
	// 		derivedLabelClass.push(FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(2));
	// 		derivedInputClass.push(FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(10));
	// 	}
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	// derivedLabelClass = [`col-md-${labelDiv}`];
	// 	// derivedInputClass = [`col-md-${inputDiv}`];
	// 	derivedLabelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)];
	// 	derivedInputClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)];
	// 	if (this.formElement.row) {
	// 		this.rowClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row];
	// 		// this.rowClass = ['row'];
	// 		derivedLabelClass.push(FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row);
	// 		// derivedLabelClass.push('right-text');
	// 	} else {
	// 		derivedInputClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)];
	// 		derivedLabelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)];
	// 		// derivedInputClass = ['col-md-12'];
	// 		// derivedLabelClass = ['col-md-12'];
	// 	}
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// }

	onBlur() {
		this.makeDirty();
		if (this.value === undefined) {
			return;
		}
		this.blur.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	onKeydown(event) {
		const allowedKeys: any = [
			KEYS.BACKSPACE,
			KEYS.ARROW_LEFT,
			KEYS.ARROW_RIGHT,
			KEYS.TAB];
		const key: string = event.key;
		if (allowedKeys.indexOf(key) >= 0) {
			return;
		}
		const currentValue = this.value && (this.value.aadharNumber  === null) ? STRING.EMPTY : String(this.value.aadharNumber );
		if (currentValue === STRING.EMPTY && key === STRING.ZERO) {
			return event.preventDefault();
		}
		if (this.formElement.maxFieldLength >= 0) {
			if (this.formElement.maxFieldLength === currentValue.length) {
				return event.preventDefault();
			}
		}
		const charAllowedPattern = this.formElement.charPattern;
		if (!charAllowedPattern) {
			return;
		}
		const charAllowedRegex = new RegExp(charAllowedPattern, 'g');
		const match = key.match(charAllowedRegex);
		if (!match) {
			return event.preventDefault();
		}
	}

	discardKey(event) {
		const key: string = event.key;
		const allowedKeys: any = [KEYS.TAB];
		if (allowedKeys.indexOf(key) >= 0) {
			return;
		}
		event.preventDefault();
	}


	onChange() {
		this.makeDirty();
		this.inputValue = this.value;
		this.valueChange.emit(this.value);
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}


	validateAdhar() {
		let gender: any;
		switch (this.loggedInUser.personalDetails.gender) {
			case 'Female': gender = 'F'
				break;
			case 'Male': gender = 'M'
				break;
			case 'Transgender': gender = 'O'
				break;
		}
		const data = {
			'AadharNumber': this.value.aadharNumber ,
			'Name': this.loggedInUser.personalDetails.firstName,
			'Gender': gender,
			'AadhaarType': 'A'
		}
		this.aadharService.validateAdhaarNumber(data)
			.subscribe(res => {
				if (res) {
					if (res.ResponseCode === '200') {
						this._isAadhaarValidated = true;
						this.forceDisable = true;
						this.value.aadhaarRef = res.RefKey;
						this.value.aadhaarVerified = true;
						this.value = (this._validValue(this.value) && this.value) || this._generateObject();
						this.value.aadharNumber = this._getEncryptedData(data.AadharNumber);
						// this.value.encryptedValue = this._getEncryptedData(data)
						toastr.success('Verified');
					} else {
						toastr.error(res.Status);
					}
					// this.onChange();
				}
			}, err => {
				console.log(err.message);
			});
	}

	_getEncryptedData(aadno) {
		let data = aadno;
		data = 'XXXXXXXX'.concat(data.slice(-4))
		return data;
	}



	getAdharNumber(encryptedValue) {
		if (encryptedValue !== null) {
			this._isAadhaarValidated = true;
			this.forceDisable = true;
			this.value.aadhaarRef = encryptedValue.aadhaarRef;
			this.value.aadhaarVerified = true;
			this.value.aadharNumber = encryptedValue.aadharNumber;
			this.value = (this._validValue(this.value) && this.value) || this._generateObject();
			this.formValue.patchValue(this.value);
			// this.aadharService.getAdharNumber(encryptedValue)
				// .subscribe(res => {
				// 	if (res) {
				// 		this._isAadhaarValidated = true;
				// 		this.forceDisable = true;
				// 		this.value = (this._validValue(this.value) && this.value) || this._generateObject();
				// 		this.value.encryptedValue = encryptedValue;
				// 		this.value.aadharNumber  = res.aadharNumber;
				// 		this.onChange();
				// 	}
				// });
		}
	}

	get validAadharChecksum() {
		if (this.formValue && this.formValue.errors && this.formValue.errors.aadharChecksum) {
			return false;
		}
		return true;
	}

	private _validValue(value) {
		return value && typeof value === STRING.OBJECT;
	}

	set inputValue(value) {
		if (this.formValue) {
			this.formValue.setValue(this.value);
		}
	}
	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}
	isDisabled() {
		return (this.disabled || this.forceDisable || this.formElement.readOnly) ? STRING.EMPTY : null;
	}

}
